export default __webpack_public_path__ + "static/media/logout.c2601b0a.svg";